'use client';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { ComplexManagementData } from '../page';

type Props = {
  title: string;
  description: string;
  data: ComplexManagementData[];
};

export default function ComplexManagement({ title, description, data }: Props) {
  const [selected, setSelected] = useState(0);

  return (
    <>
      <div className="flex flex-col max-w-5xl w-2/3 py-12 select-none">
        <div>
          <h3 className="text-4xl font-semibold title-white">{title}</h3>
          <p className="text-white text-opacity-50">{description}</p>
        </div>
        <div className="mt-6 grid grid-cols-2 lg:grid-cols-4 items-center gap-10">
          {data.map((item, index) => (
            <div
              onClick={() => setSelected(index)}
              key={index}
              className={
                'rounded-lg cursor-pointer flex flex-col space-y-2 justify-center p-4 h-32 min-w-32 w-full transition-colors duration-200 ease-in-out border-[4px] border-opacity-0 border-primary hover:border-opacity-25 ' +
                (index === selected ? `bg-white bg-opacity-5` : ' ')
              }
            >
              <FontAwesomeIcon height={40} className="h-10" icon={item.icon} />
              <div className="text-white text-opacity-75 text-center">
                {item.title}
              </div>
            </div>
          ))}
        </div>
        <div className="mt-8 min-h-40 flex flex-col sm:flex-row bg-primary bg-opacity-20 rounded-xl w-full overflow-hidden">
          <div className="py-4 w-full sm:w-1/3 bg-white bg-opacity-10 flex items-center justify-center">
            <FontAwesomeIcon
              height={80}
              className="h-20"
              icon={data[selected].icon}
            />
          </div>
          <div className="w-full sm:w-2/3 flex items-center justify-start p-8 select-text cursor-default max-sm:text-center">
            {data[selected].text}
          </div>
        </div>
      </div>
    </>
  );
}
